import React from 'react';

import Contentful from 'brand/app/contentful/components/Contentful';
import ShowOnDesktop from 'brandComponents/Responsive/ShowOnDesktop';
import ShowOnMobile from 'brandComponents/Responsive/ShowOnMobile';

import {ModuleLinks, ModuleMedia, ModuleText} from '../Common';

import {IDiscoverMore} from './IDiscoverMore';

import styles from './DiscoverMore.module.scss';

const DiscoverMore = (props: IDiscoverMore) => {
	const {title, description, textColorVariant, links, backgroundColor, images, carousel} = props;
	const contentBackground = backgroundColor === 'pink' ? '#F6E6E2' : '#000000';
	const contentStyle = {
		'--content-background-color': contentBackground,
	} as React.CSSProperties;

	return (
		<div className={styles['module-discover-more']}>
			<div className={styles['module-discover-more__content']} style={contentStyle}>
				{images.length === 1  ? (
					<ModuleMedia
						classNames={styles['module-discover-more__media-single']}>
						<Contentful initialData={images[0]} />
					</ModuleMedia>
				) :
					carousel && images.length === 2 && (
						<>
							<ShowOnDesktop classNames={styles['module-discover-more__media']}>
								{images.map((item, key) =>
									<Contentful key={key} initialData={item} />
								)}
							</ShowOnDesktop>
							<ShowOnMobile classNames={styles['module-discover-more__media']}>{carousel}</ShowOnMobile>
						</>
					)}
				<div className={styles['module-discover-more__content-wrapper']}>
					<div className={styles['module-discover-more__text-wrapper']}>
						{title && (
							<div className={styles['module-discover-more__title']}>
								<ModuleText contentfulField="title" text={title} colorVariant={textColorVariant} />
							</div>
						)}
						{description && (
							<div className={styles['module-discover-more__description']}>
								<ModuleText contentfulField="description" text={description} colorVariant={textColorVariant} />
							</div>
						)}
						{links.length > 0 && (
							<ModuleLinks className={styles['module-discover-more__cta-wrapper']}>{links}</ModuleLinks>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default DiscoverMore;
